import { render, staticRenderFns } from "./EditableDataTable.vue?vue&type=template&id=15fbe4bd"
import script from "./EditableDataTable.vue?vue&type=script&lang=js"
export * from "./EditableDataTable.vue?vue&type=script&lang=js"
import style0 from "./EditableDataTable.vue?vue&type=style&index=0&id=15fbe4bd&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports